import { QueryClient } from "@tanstack/react-query";
import { getByPath } from "../../shared/helpers/object.helper";
import { Question } from "@coworker/app/src/components/MFAQ/BackendApiRepository/QuestionResponse";

const MFAQ_QUESTION_KEY = "question";
const MFAQ_VOTES_KEY = "votes";

type ResetVotesProps = {
  questionId: string;
  area: string;
};

export const resetVotesAfterComplete = (
  task: Record<string, unknown>,
  props: ResetVotesProps,
  queryClient: QueryClient
): void => {
  const questionId = String(getByPath(task, props.questionId) ?? "");
  const area = String(getByPath(task, props.area) ?? "");
  if (!questionId) return;

  queryClient.setQueriesData<Question>(
    { queryKey: [MFAQ_QUESTION_KEY, questionId] },
    (old) => {
      if (!old?.upvotes_by_area) return old;
      return {
        ...old,
        upvotes_by_area: old.upvotes_by_area.map((a) =>
          a.area === area ? { ...a, votes_unresolved: 0 } : a
        ),
      };
    }
  );
  queryClient.invalidateQueries({
    queryKey: [MFAQ_QUESTION_KEY, questionId],
  });
  queryClient.invalidateQueries({ queryKey: [MFAQ_VOTES_KEY, questionId] });
};
